import setting from '../common/data/url.json'
const axios = require('axios');

export function doLogin(username, password) {
    var url = setting.Host + setting.ApiLogin;
    return axios.post(url, {
        username: username,
        password: password
    });
}